<template>
  <div>
    <div>
      <div v-if="loaded && programs.length === 0">
        <div class="alert alert-primary" role="alert">
          برنامه‌ای یافت نشد، برای افزودن برنامه‌
          <router-link
            :to="{ name: 'programs-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>

    <div v-if="loaded && programs.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>نوع</th>
                <th>پلن</th>
                <th>آرشیو</th>
                <th>تاریخ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="program in programs"
                :key="program.id"
                :class="{ 'bg-danger': isStopped(program) }"
              >
                <td>{{ program.name }}</td>
                <td>{{ programTypes[program.type] }}</td>
                <td>{{ programPlans[program.plan] }}</td>
                <td>{{ program.archive_status === 1 ? "بله" : "خیر" }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(program.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{ name: 'programs-show', params: { id: program.id } }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                  <router-link
                    v-show="!isStopped(program)"
                    :to="{ name: 'programs-edit', params: { id: program.id } }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-edit"></i>
                    ویرایش
                  </router-link>
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(program.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                  <!--              <button-->
                  <!--                v-show="!isStopped(program)"-->
                  <!--                class="btn btn-xs btn-outline-danger mr-1"-->
                  <!--                @click="stop(program.id)"-->
                  <!--              >-->
                  <!--                توقف-->
                  <!--              </button>-->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="programsPagination.lastPage > 1">
      <b-pagination
        v-model="programsPagination.currentPage"
        :total-rows="programsPagination.total"
        :per-page="programsPagination.perPage"
        aria-controls="my-table"
        @input="updatePrograms()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_PROGRAMS,
  DESTROY_PROGRAM,
  STOP_PROGRAM
} from "@/core/services/store/programs.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "programs",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "برنامه‌‌ها" }]);

    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "programs-create" },
          class: "btn-primary"
        }
      ]
    });
    this.updatePrograms();
  },
  computed: {
    ...mapGetters([
      "programs",
      "programsPagination",
      "programTypes",
      "programPlans"
    ])
  },
  methods: {
    isStopped(program) {
      return program.events.length;
    },
    updatePrograms() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_PROGRAMS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف برنامه‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_PROGRAM, id).then(() => {
            this.updatePrograms();
          });
        }
      });
    },
    stop(id) {
      Swal.fire({
        title: "",
        text: "آیا از توقف برنامه‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(STOP_PROGRAM, id).then(() => {
            this.updatePrograms();
          });
        }
      });
    }
  }
};
</script>
